// STYLES
import * as Style from "./LockerStatisticElementStyle";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { IProps } from "./LockerStatisticElementModel";

// ASSETS
import LockerStationIcon from "assets/Icons/IconStatie.svg";

// REDUX

// COMPONENTS

const LockerStatisticElement = (props: IProps) => {
  // PROPS
  const { onClick = () => {}, lockerDetails } = props;

  // CONSTANTS USING LIBRARIES
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return (
    <Style.LockerStatisticElementContainer onClick={onClick}>
      <Style.LockerStatisticLeftSideWrapper>
        <Style.LockerStatisticElementTitle>
          {lockerDetails.name}
        </Style.LockerStatisticElementTitle>
        <Style.LockerStatisticStatus>
          {lockerDetails.status}
        </Style.LockerStatisticStatus>
        <Style.LockerStatisticImageContainer>
          <img src={LockerStationIcon} alt="" />
        </Style.LockerStatisticImageContainer>
      </Style.LockerStatisticLeftSideWrapper>

      <Style.LockerStatisticRightSideWrapper>
        <Style.RightSideRow>
          <Style.RowTitle>
            {t("page.dashboard.lockerStatistics.availableBoards")}
          </Style.RowTitle>
          <Style.RowValue>
            {lockerDetails.noOfAvailableSupBoards} /{" "}
            {lockerDetails.noOfSupBoards}
          </Style.RowValue>
        </Style.RightSideRow>

        <Style.RightSideRow>
          <Style.RowTitle>
            {t("page.dashboard.lockerStatistics.availableDoors")}
          </Style.RowTitle>
          <Style.RowValue>
            {lockerDetails.noOfAvailableSlots} / {lockerDetails.noOfSlots}
          </Style.RowValue>
        </Style.RightSideRow>
      </Style.LockerStatisticRightSideWrapper>
    </Style.LockerStatisticElementContainer>
  );
};

export default LockerStatisticElement;
